module.exports = {"id":"issues","title":"Reporting issues","content":"<h1>Reporting issues</h1>\n<p>todo</p>\n"}